class ConsumersContainerController {
    constructor(createAutoQuery, consumerPrompt, $session, $window) {
        $session.authorize(s => !s.isCorpOrAbove() && {consumer: {consumerId: s.userAuthId}});
        let options = {
            url: 'QueryConsumers.json',
            //fields: 'Id,CompanyName,Address,Address2,City,State,Zip,Status',
            pageSize: 24,
            orderBy: 'Id',
            autoLoad: true,
            append: false,
            sortOptions: {

                'Id': 'Id: Low to High',
                '-Id': 'Id: High to Low',
                'DisplayName': 'Name: A to Z',
                '-DisplayName': 'Name: Z to A',
                'Email': 'Email: A to Z',
                '-Email': 'Email: Z to A',
                'CreatedDate': 'Created: Newest',
                '-CreatedDate': 'Created: Oldest',
                'Address': 'Address: A to Z',
                '-Address': 'Address: Z to A',
                'Address2': 'Address2: A to Z',
                '-Address2': 'Address2: Z to A',
                'City': 'City: A to Z',
                '-City': 'City: Z to A',
                'State': 'State: A to Z',
                '-State': 'State: Z to A',
                'Zip': 'Zip: 1 to 9',
                '-Zip': 'Zip: 9 to 1',
                'Status': 'Status: A to Z',
                '-Status': 'Status: Z to A'
            }
        };
        this.query = createAutoQuery(options);
        this.prompt = consumerPrompt;
        this.$window = $window;
    }
    load(){return this.query.load.apply(this.query, arguments);}
    add(){return this.prompt.add().then(() => this.query.load(true));}
    edit(consumer){return this.prompt.edit(consumer).then(() => this.query.load(true));}
    delete(consumer){return this.prompt.delete(consumer).then(() => this.query.load(true));}
}

class ConsumersContainer{
    constructor(){
        this.bindings= {
        };
        this.controller = ConsumersContainerController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumers-container.html'
    }
}

angular.module('emun.consumer').component('consumersContainer', new ConsumersContainer());

export { ConsumersContainer, ConsumersContainerController};